import { analytics, SandboxEvents } from '@/lib/analytics'
import type { SandboxSource } from '@/stores/sandbox-dialog'

interface SandboxDialogOpenedEventData {
  source: SandboxSource | null
  userRole: 'Administrator' | 'User'
  currentPlan: string
  isManaged: boolean
}

interface SandboxDialogClosedEventData extends SandboxDialogOpenedEventData {
  converted: boolean
  durationMs: number
}

export function trackSandboxDialogOpened(
  data: SandboxDialogOpenedEventData,
): void {
  analytics.track(SandboxEvents.DIALOG_OPENED, {
    source: data.source,
    user_role: data.userRole,
    current_plan: data.currentPlan,
    is_managed: data.isManaged,
  })
}

export function trackSandboxDialogClosed(
  data: SandboxDialogClosedEventData,
): void {
  analytics.track(SandboxEvents.DIALOG_CLOSED, {
    source: data.source,
    user_role: data.userRole,
    current_plan: data.currentPlan,
    is_managed: data.isManaged,
    converted: data.converted,
    duration_ms: data.durationMs,
  })
}
